import { ExpressionBasedColumnBase } from './expression-based.column.base';
import { Metamodel } from '../base/model';

import { DataFlowExpression } from './dataflowexpression';
import { IViolation, IModel } from '../base/annotation';
import { Owned } from '../base/named';
import { BooleanDataFlowType } from './dataflow-datatype';

@Metamodel.model({
    name: 'templateExpressionBasedColumnBase',
    abstract: true
})
export abstract class TemplateExpressionBasedColumnBase extends ExpressionBasedColumnBase {
    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        display: stringResources.DataFlowTemplateCondition,
        constraint: {
            required: false,
            validator: TemplateExpressionBasedColumnBase._templateConditionValidator
        }
    })
    public templateCondition: DataFlowExpression = this._createTemplateConditionExpression();

    @Metamodel.attribute({
        display: 'regexString',
        constraint: {
            required: false,
            validator: TemplateExpressionBasedColumnBase._regexStringValidator
        }
    })
    public regexString: string = '';

    /*
     * The expression for the new each funtion level
     */
    @Metamodel.attribute({
        display: stringResources.Expression
    })
    public hierarchyLevelExpression: DataFlowExpression = Owned.create<DataFlowExpression>(DataFlowExpression.MODEL, this);

    public deepHierarchy: boolean = false;

    private static _templateConditionValidator(regexMapping: TemplateExpressionBasedColumnBase, expression: DataFlowExpression): IViolation[] | undefined {
        if (!TemplateExpressionBasedColumnBase._atLeastOneConditionGiven(expression, regexMapping.regexString)) {
            return [{
                context: regexMapping,
                message: () => stringResources.DataFlowColumnExpressionRequiredError
            }];
        }
        return undefined;
    }

    private static _atLeastOneConditionGiven(templateExpression: DataFlowExpression, regexString: string): boolean {
        const hasTemplateCondition = !!(templateExpression && templateExpression.expression);
        const hasRegexString = !!regexString;
        return hasTemplateCondition || hasRegexString;
    }

    private static _regexStringValidator(regexMapping: TemplateExpressionBasedColumnBase, regexString: string): IViolation[] | undefined {
        if (regexString) {
            // Test the regex for validity
            try {
                new RegExp(regexString);
            } catch {
                return [{
                    context: regexMapping,
                    message: () => stringResources.DataFlowRegexInvalidError
                }];
            }
        }

        return undefined;
    }

    private _createTemplateConditionExpression(): DataFlowExpression {
        const templateCondition = Owned.create<DataFlowExpression>(DataFlowExpression.MODEL, this);
        templateCondition.requiredReturnType = BooleanDataFlowType.TYPE;
        return templateCondition;
    }
}
